'use strict';

/*global app*/
/*global blockElement*/
/*global unBlockElement*/

function UnholdDocument() {
  this.$container = $('body');

  this.init();
}

UnholdDocument.prototype = $.extend({}, {
  constructor: 'UnholdDocument',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    $('body').on('click', '.unhold-document', function () {
      _this.unholdDocument($(this).data('web_document_rid'), $(this).data('redirect_url'));

      return false;
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  unholdDocument: function unholdDocument(webDocumentRID, redirectUrl) {
    var _this = this;

    blockElement(_this.$container);
    $.get(app.path('process_unhold_document'), { WebDocumentRID: webDocumentRID }, function (res) {
      unBlockElement(_this.$container);

      if (res.msg === 'SUCCESS') {
        location.href = redirectUrl;
      } else {
        app.viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.registerCallbacks();

    return _this;
  }
});
